import React from "react";
import { Carousel } from "react-responsive-carousel";
import { TypeAnimation } from "react-type-animation";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Header from "./Header";

const Hero = () => {
  const slides = [
    {
      image: "/images/hero.avif",
      title: "Guerate Energy",
      subtitle:
        "We are a social enterprise creating access to clean cooking gas (LPG), and ensuring its affordability through our Waste-to-Fuel mechanism.",
      animationText: [
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
      ],
    },
    {
      image: "/images/goal-1.avif",
      title: "Guerate Energy",
      subtitle:
        "We are harnessing the untapped potential of recyclables to deliver access to affordable clean energy for rural kitchens.",
      animationText: [
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
      ],
    },
    {
      image: "/images/fire.avif",
      title: "Guerate Energy",
      subtitle:
        "Reducing Greenhouse emission and carbon footprints from cooking activities in rural communities",
      animationText: [
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
        "Empowering communities through affordable, sustainable energy solutions.",
        1000,
      ],
    },
  ];

  return (
    <div className="h-[100vh] w-[100vw]">
      <Carousel
        autoPlay
        infiniteLoop
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        interval={5000}
      >
        {slides.map((slide, index) => (
          <div
            key={index}
            className="h-[100vh] w-[100vw] flex items-center justify-center"
            style={{
              backgroundImage: `url(${slide.image})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <div className="flex h-full w-full bg-[#000] bg-opacity-70 flex-col items-center justify-center gap-4">
              <h1 className="text-[#38761d] text-[45px] md:text-7xl font-bold">
                {slide.title}
              </h1>
              <h2 className="text-[#fff] text-left md:text-center md:text-2xl font-semibold w-[90%]">
                {slide.subtitle}
              </h2>
              <TypeAnimation
                sequence={slide.animationText}
                wrapper="span"
                className="md:text-[20px] text-[16px] text-left md:text-center"
                speed={50}
                style={{
                  color: "#f46524",
                  maxWidth: "90%",
                  maxHeight: "30px",
                }}
                repeat={Infinity}
              />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Hero;
